import { useCallback, useEffect, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react'
import { styled } from '@mui/material'
import { PageArea, PageProps } from '..'
import { BulkSheetView } from '../../containers/BulkSheetView'
import { pageComponent } from '../../higher-order-components/pageComponent'
import Loading from '../../components/process-state-notifications/Loading'
import ReloadButton from '../../containers/BulkSheetView/components/header/ReloadButton'
import { ProgramOverviewDto } from '../../../infrastructure/api/programs'
import { useProgramGridOptions } from './gridOptions'
import { useProgramData } from './hooks/useProgramData'

const Programs = (_props: PageProps) => {
  const gridRef = useRef<AgGridReact<ProgramOverviewDto>>(null)
  const bulkSheetRef = useRef<HTMLDivElement>(null)

  const { data, loading, fetchPrograms } = useProgramData()
  const gridOptions = useProgramGridOptions()

  const handleReload = useCallback(() => {
    fetchPrograms()
  }, [fetchPrograms])

  useEffect(() => {
    fetchPrograms()
  }, [fetchPrograms])

  return (
    <PageArea>
      <Header>
        <ReloadButton onReload={handleReload} />
      </Header>
      <BulkSheetView
        ref={bulkSheetRef}
        gridRef={gridRef}
        gridOptions={gridOptions}
        rowData={data}
      />
      <Loading isLoading={loading} elem={bulkSheetRef.current} />
    </PageArea>
  )
}

const Header = styled('div')({
  display: 'flex',
  alignItems: 'center',
  margin: '10px 10px 5px 10px',
  overflowX: 'auto',
  overflowY: 'hidden',
  minHeight: '47px',
})

export default pageComponent(Programs)
